import type { CSSProperties } from 'react'

interface IconProps {
  color?: string
  className?: string
  style?: CSSProperties
}

export default function LogoIcon({ color, className, style }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M22.4062 0.375C23.4375 0 24.5625 0 25.5 0.375L45 7.6875C46.7812 8.34375 47.9062 10.0312 47.9062 11.9062V33C47.9062 34.6875 46.9687 36.2812 45.4687 37.0312L25.9687 46.7812C24.6562 47.4375 23.25 47.4375 21.9375 46.7812L2.43748 37.0312C0.937475 36.2812 -2.47955e-05 34.6875 -2.47955e-05 33V11.9062C-2.47955e-05 10.0312 1.12498 8.34375 2.90623 7.6875L22.4062 0.375ZM24 6.1875L5.99998 12.9375V13.0312L24 20.3438L42 13.0312V12.9375L24 6.1875ZM27 39.5625L42 32.0625V19.5L27 25.5938V39.5625Z"
        fill={color ?? '#CCFF00'}
      />
    </svg>
  )
}
